import { render, staticRenderFns } from "./demo-list-side-bar.vue?vue&type=template&id=0d13982e&scoped=true&"
import script from "./demo-list-side-bar.vue?vue&type=script&lang=js&"
export * from "./demo-list-side-bar.vue?vue&type=script&lang=js&"
import style0 from "./demo-list-side-bar.vue?vue&type=style&index=0&id=0d13982e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d13982e",
  null
  
)

export default component.exports